/**
 * Collection-page "Notify me" trigger for the Klaviyo Back-in-Stock form.
 *
 * The PDP is where the working Klaviyo form-embed-block lives. On
 * collection pages we can't replicate the popup inline (variant context
 * lives on the PDP), so we redirect to the product page with a #notify
 * anchor. The PDP-side listener below detects the anchor on arrival and
 * auto-clicks the Klaviyo button, opening the popup.
 */
(function () {
  'use strict';

  // Collection-page click handler: redirect to PDP with #notify anchor.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-notify-trigger');
    if (!btn) return;

    e.preventDefault();

    var productUrl = btn.getAttribute('data-product-url');
    if (productUrl) {
      window.location.href = productUrl + '#notify';
    }
  });

  // PDP-side auto-open: if we arrived with #notify, click the Klaviyo
  // BIS button once it's in the DOM. Klaviyo injects it asynchronously,
  // so poll briefly.
  if (window.location.hash === '#notify') {
    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      var bisBtn = document.querySelector(
        '#klaviyo-bis-button-container button, [data-a11y-identifier^="bis-button-"] button'
      );
      if (bisBtn) {
        clearInterval(interval);
        bisBtn.click();
        if (history.replaceState) {
          history.replaceState(null, '', window.location.pathname + window.location.search);
        }
      } else if (attempts >= 50) {
        // ~10s; give up silently.
        clearInterval(interval);
      }
    }, 200);
  }
})();
